function assertQuickActionItems(value) {
  if (!Array.isArray(value)) {
    throw new TypeError("QuickActions.setItems: items must be an array");
  }
  var seen = /* @__PURE__ */ new Set();
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;
      if (!item || typeof item !== "object" || typeof item.id !== "string" || !item.id.trim() || typeof item.title !== "string" || !item.title.trim() || item.subtitle !== void 0 && typeof item.subtitle !== "string" || seen.has(item.id)) {
        throw new TypeError("QuickActions.setItems: items require unique non-empty id and title with optional string subtitle");
      }
      seen.add(item.id);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}
function assertQuickActionListener(value) {
  if (typeof value !== "function") {
    throw new TypeError("QuickActions.addListener: listener must be a function");
  }
}
export {
  assertQuickActionItems,
  assertQuickActionListener
};
//# sourceMappingURL=validate.js.map
